import { mapActions } from 'vuex';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import { formMixin } from '@/components/forms/mixin';

export default {
  mixins: [
    formMixin,
  ],
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      dontShowAgain: false,
      swiperOptions: {
        direction: 'horizontal',
        pagination: '.attach-to-home__pagination',
        paginationClickable: true,
      },
      items: [
        {
          textTop: this.$txt('attach-to-home.txt1'),
          image: 'step1',
          textBottom: this.$txt('attach-to-home.txt1-bottom'),
        },
        {
          textTop: this.$txt('attach-to-home.txt2'),
          image: 'step2',
          textBottom: '',
        },
        {
          textTop: this.$txt('attach-to-home.txt3'),
          image: 'step3',
          textBottom: '',
        },
      ],
    };
  },
  methods: {
    ...mapActions('app', ['dontShowAttachToHomeNotification']),
  },
  beforeDestroy() {
    if (this.dontShowAgain) this.dontShowAttachToHomeNotification();
  },
};



// WEBPACK FOOTER //
// ./src/components/attach-to-home/attach-to-home.js